export enum CookieName {
    Cart = 'cart_state',
    Authentication = 'X-Auth',
    CookiePolicy = 'cookiePolicy',
    ConsentVersion = 'cookieConsentVersion',
}
